define('modules/stats/views/navigation',['require','exports','module','base/layout','backbone','common/views/monthpicker','ldsh!../templates/navigation'],function (require, exports, module) {
  'use strict';

  var Layout = require('base/layout'),
    Backbone = require('backbone'),
    Datepicker = require('common/views/monthpicker');

  module.exports = Layout.extend({
    template: require('ldsh!../templates/navigation'),

    regions: {
      datepicker: '.js-monthpicker',
    },

    constructor: function (options) {
      this.viewModel = options.filters;
      module.exports.__super__.constructor.apply(this, arguments);
    },

    helpers: function () {
      return {};
    },

    initialize: function (options) {
      var datepicker = new Datepicker({
        model: options.date,
        className: 'ed-stats-dateFilter ed-pages-filter hidden',
        viewToggler: this,
        buttonTranslationKey: 'common.okButton',
        noLabel: true,
      });

      this.$datepicker.show(datepicker);
      datepicker.toggle();
    },
    onRender: function () {
      this.$el.i18n();
    },
  });
});

